import { Component, Entity2D, clamp } from '../../../odie';
import { CountBlockOptionDef } from '../../defs/block';
import { LaserBoxBlockProps } from './LaserBoxBlock';
import { LaserBoxBlockView } from './LaserBoxBlockView';
import { PositionComponent } from '../../components/PositionComponent';

export type LaserBoxBlockComponentOptions = {
  props: LaserBoxBlockProps;
  option?: number;
};

export class LaserBoxBlockComponent implements Component {
  public static readonly NAME = 'blockLaserBox';
  public entity!: Entity2D;
  public view!: LaserBoxBlockView;
  private props!: LaserBoxBlockProps;

  public init(args: LaserBoxBlockComponentOptions): void {
    this.props = args.props;
    this.view = new LaserBoxBlockView(
      args.props,
      this.optionToCount(args.option ?? 0),
    );
    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();

    // Pass the map position to the view for clip bounds calculation
    const positionComponent = this.entity.getComponent(PositionComponent);
    if (positionComponent?.mapPosition) {
      this.view.setMapPosition(positionComponent.mapPosition);
    }

    // Update clip bounds when position changes (e.g., when falling)
    if (positionComponent) {
      positionComponent.onPositionChange = (position) => {
        this.view.setMapPosition(position);
      };
    }
  }

  public getGameplayState(): number {
    return this.countToOption(this.count) ?? 0;
  }

  public get orientation() {
    return this.view.orientation;
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }

  private optionToCount(option: number) {
    const options = this.props.options as CountBlockOptionDef[];
    if (option < 0 || option >= options.length) option = 0;
    return options[option].count;
  }

  private countToOption(count: number) {
    const options = this.props.options as CountBlockOptionDef[];
    const index = options.findIndex((opt) => {
      return opt.count === count;
    });
    return clamp(index, 0, options.length - 1);
  }
}
